<div class="profile-container">
    <div class="">
        <div class="profile-content">

            <div class="personal-details">

                <div class="header-block">
                <div class="header-title">
                  <!-- <p>Master Data / Asset Group</p> -->
                  <app-breadcrumb></app-breadcrumb>
                </div>
                <div class="add-block">
                

                  <div class="search">
                    <form autocomplete="off" >
                      <input type="text" placeholder="search" (keyup.enter)="getAllUOMMasterByWildSearchWithoutPagination()" [ngModelOptions]="{standalone: true}" [(ngModel)]="searchKey">
                    </form>
                    <i class="bi bi-search" (click)="getAllUOMMasterByWildSearchWithoutPagination()"></i>
                  </div>
  
               
  
                  <button *ngIf="actionControls.isAdd" data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> {{ 'generic.add' | translate }}</button>
                <div class="filter-icon">
                    <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                  </div>
 
                </div>
              </div>
              
                <table class="table table-striped">
                    <thead>
                        <tr>
                  
                        <th style="width: 40%;">{{ 'uom-master.uomName' | translate }}</th>
                        <th style="width: 40%;">{{ 'uom-master.description' | translate }}</th>
                        <th style="width: 20%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate }}</th>
    
                        </tr>
                    </thead>
                </table>
                <div *ngIf="!isLoading">
                    <div class="data-view" *ngFor="let uom of uomData | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: page,
                        totalItems: count
                        }  ;let i = index">
        
                        <p style="width: 40%;">{{uom.uomName}}</p>
                        <p style="width: 40%;">{{uom.description}}</p>         
                        <p class="action-buttons" style="width: 20%;padding-left: 25px;">
                            <i *ngIf="actionControls.isDelete" (click)="selectDelete(uom.id,uom)" title="Delete" class="bi bi-trash" data-toggle="modal" data-target="#deleteModal"></i>
                        </p>                
                    </div>
                </div>
        
        
                <div class="loader" *ngIf="isLoading">
                    <div class="spinner"></div>
                </div>
        
                <div class="loader"  *ngIf="!isLoading && uomData.length == 0">
                    <div class="no-data">
                        <img src="assets/no-data-6.png" alt="">
                        <p>no data found</p>
                    </div>
                    
                </div>
        
                <div class="paginator">
                    <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="count"
                        [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
                </div>
        
          
            </div>
  
        </div>
    </div>
  </div>
  
  
  <div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'uom-master.headings.add' | translate }}
            <span data-dismiss="modal">
                <i (click)="formReset()" class="bi bi-x-lg"></i>
            </span>
        </h5>
      </div>
      <div class="modal-body">
  
        <div [formGroup]="form">
            <div class="row">
                <div class="col-md-12 col-lg-12">
                    <div class="form-group">
                        <label>{{ 'uom-master.uomName' | translate }} <span class="required">*</span></label>
                        <input formControlName="uomName" type="text" class="form-control">
                    </div>
                </div>
                
                <div class="col-md-12 col-lg-12">
                    <div class="form-group">
                        <label>{{ 'uom-master.description' | translate }}</label>
                        <textarea class="form-control" formControlName="description" name="" id="" cols="30" rows="10"></textarea>
                    </div>
                </div>
              
              
                <div class="col-md-12 col-lg-12">
                    <div formArrayName="nameValueList">
                        <div *ngFor="let param of form.controls.nameValueList['controls'];let i = index;let last = last" [formGroupName]="i">
                            <div class="row">
                                <div class="col-md-5 col-lg-5">
                                    <div class="form-group">
                                        <input formControlName="name" placeholder="enter name" type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <input formControlName="value" placeholder="enter value" type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-1 col-lg-1 paramBtn" *ngIf="last">
                                    <svg xmlns="http://www.w3.org/2000/svg" (click)="addInfoObject()" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" *ngIf="i!=0" (click)="removeParamObject(i)" fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                                    </svg>
                                </div>
                                <div class="col-md-1 col-lg-1 paramBtn1" *ngIf="!last">
                                    <!-- <div class="form-group">
                                        <button style="width: 100%;" (click)="removeParamObject(i)">Remove</button>
                                    </div> -->
                                    <svg xmlns="http://www.w3.org/2000/svg" (click)="removeParamObject(i)" fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      <div class="modal-footer">
        <button type="button" id="closeModalButton" (click)="formReset()" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
        <button type="button" (click)="addUOM()" class="btn btn-primary">{{ 'generic.add' | translate }}</button>
      </div>
    </div>
  </div>
  </div>
  </div>
  


  <!-- <div class="modal fade" id="exampleModalView" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
        </div>
        <div class="modal-body">
    
          <div>
              <div class="row view" *ngFor="let customer of singleCustomerInfo">
                  <div class="col-md-6 col-lg-6">
                      <div class="form-group">
                          <label>Name</label>
                          <input type="text" value="{{customer.name}}" class="form-control">
                      </div>
                  </div>
                  
                  <div class="col-md-6 col-lg-6">
                      <div class="form-group">
                          <label>Description</label>
                          <textarea class="form-control" value="{{customer.description}}" name="" id="" cols="30" rows="10"></textarea>
                      </div>
                  </div>
                  
                  <div class="col-md-12 col-lg-12">
                      <div class="form-group" style="text-align: center;">
                          <label >Params</label>
                      </div>
                  </div>
                  <div class="col-md-12 col-lg-12" style="padding: 0;" *ngFor="let params of customer.customerParamEntityList">
                    <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                            <input type="text" value="{{params.name}}" class="form-control">
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                            <input type="text" value="{{params.value}}" class="form-control">
                        </div>
                    </div>
                  </div>
              </div>
           
    
          </div>
    
     
        <div class="modal-footer">
          <button type="button" id="closeModalButton"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
    </div>
    </div> -->



 
<div class="modal fade" id="exampleModalView" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{ 'uom-master.headings.detail' | translate }}
            <span data-dismiss="modal">
                <i class="bi bi-x-lg"></i>
            </span>
          </h5>
        </div>
        <div class="modal-body view">
    
          <div *ngFor="let uom of singleUomMaster">
              <div class="row">
                  <div class="col-md-12 col-lg-12">
                      <div class="form-group">
                          <label>{{ 'uom-master.uomName' | translate }}</label>
                          <input type="text" value="{{uom.uomName}}" class="form-control">
                      </div>
                  </div>
                  
                  <div class="col-md-12 col-lg-12">
                      <div class="form-group">
                          <label>{{ 'uom-master.description' | translate }}</label>
                          <textarea class="form-control" value="{{uom.description}}" name="" id="" cols="30" rows="10"></textarea>
                      </div>
                  </div>
                
                
                  <div class="col-md-12 col-lg-12">
                          <div *ngFor="let list of uom.nameValueList;let i = index;let last = last">
                              <div class="row">
                                  <div class="col-md-6 col-lg-6">
                                      <div class="form-group">
                                          <input placeholder="enter name" value="{{list.name}}" type="text" class="form-control">
                                      </div>
                                  </div>
                                  <div class="col-md-6 col-lg-6">
                                      <div class="form-group">
                                          <input placeholder="enter value" value="{{list.value}}" type="text" class="form-control">
                                      </div>
                                  </div>
                              </div>
                          </div>
                  </div>
              </div>
          </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
        </div>
      </div>
    </div>
    </div>
</div>




<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg" (click)="closeModal()"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}}”</span>?</p>
        <div class="modal-footer">
          <button type="button" id="deleteModalButton" (click)="closeModal()" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
          <button type="button" (click)="deleteUomMaster()" class="btn btn-primary">{{ 'generic.delete' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
